import { FC } from 'react';
import { Button, Radio } from 'components/core';

import { OrderShippingMethodProps, Styled } from './';
import { useShipments } from 'reactQuery/queries';
import { LoadingSpinner, LoadingWrapper } from 'styles/sharedStyles';
import Image from 'next/legacy/image';
import { useI18n } from 'contexts/i18n';
import { useRetriveCart } from 'reactQuery/queries';
import getButtonLabel from '../OrderCheckout/CurrentStep';

const OrderShippingMethod: FC<OrderShippingMethodProps> = ({
  mode,
  onSubmit,
  isSaveShippingRateMutationLoading,
  isOrderEligibleForFreeShipping,
}) => {
  const {
    data: shippingRate,
    isLoading: isLoadingShippingRate,
    isIdle,
    isError,
    isFetching,
  } = useShipments(mode);
  const i18n = useI18n();
  const { data: currentCart } = useRetriveCart();
  const title = getButtonLabel(currentCart?.checkoutStates, 'delivery');

  if (isLoadingShippingRate || isIdle || isFetching) {
    return (
      <LoadingWrapper>
        <LoadingSpinner width="25px" height="25px" isPrimary={true} />
      </LoadingWrapper>
    );
  }
  if (isError) {
    return (
      <Styled.ErrorSection>
        Unable to calculate shipping cost, please try again later.
      </Styled.ErrorSection>
    );
  }
  return (
    <>
      {mode === 'create' && (
        <>
          <Styled.OrderShippingMethodContainer>
            <Styled.OrderShippingMethod
              isDisabled={isOrderEligibleForFreeShipping}
            >
              <Radio
                checked={true}
                onChange={() => {
                  return;
                }}
                disabled={
                  isSaveShippingRateMutationLoading ||
                  isOrderEligibleForFreeShipping
                }
                marginTop="20px"
                marginBottom="20px"
              />

              <Image
                src="/images/icons/ups.svg"
                height={30}
                width={30}
                alt="upslogo"
              />

              <Styled.ShippingTitle isDisabled={isOrderEligibleForFreeShipping}>
                {shippingRate.name}
                {!isOrderEligibleForFreeShipping && (
                  <> ({shippingRate.displayFinalPrice})</>
                )}
              </Styled.ShippingTitle>
            </Styled.OrderShippingMethod>
          </Styled.OrderShippingMethodContainer>

          <Styled.ButtonWrapper>
            <Button
              size="md"
              onClick={onSubmit}
              loading={isSaveShippingRateMutationLoading}
              disabled={isSaveShippingRateMutationLoading}
            >
              {i18n[title]}
            </Button>
          </Styled.ButtonWrapper>
        </>
      )}
      {mode === 'edit' && (
        <>
          <Styled.ReadOnlyOrderShippingMethod>
            <Image
              src="/images/icons/ups.svg"
              height={30}
              width={30}
              alt="upslogo"
            />

            <Styled.ShippingTitle>
              {shippingRate.name}
              {!isOrderEligibleForFreeShipping && (
                <> ({shippingRate.displayFinalPrice})</>
              )}
            </Styled.ShippingTitle>
          </Styled.ReadOnlyOrderShippingMethod>
        </>
      )}
    </>
  );
};

export default OrderShippingMethod;
